import * as React from "react";

import APIClient from "web_modules/APIClient";
import LabeledInput from "web_modules/LabeledInput";

const { Button } = require("react-bootstrap");

interface ResolveFlagFormProps {
  app_id: number;
  hurdle_name: string;
  flag: any;
  onUpdate: Function;
  onClose: Function;
}

class ResolveFlagForm extends React.Component<ResolveFlagFormProps, any> {
  constructor(props: ResolveFlagFormProps) {
    super(props);

    this.state = {
      message: "",
    };
  }

  saveNewMessage() {
    APIClient.get(`/flags/${this.props.app_id}/${this.props.hurdle_name}`, responseObject => {
      const flag = this.props.flag;
      flag.resolved = true;
      flag.resolution = this.state.message;
      flag.resolved_by_id = 1;
      APIClient.put(`/flags/${flag.id}`, flag, resp => {
        this.setState({
          message: "",
        });
        this.props.onUpdate();
      });
    });
  }

  render() {
    return (
      <div className="hurdle-communication__form hurdle-communication__form--resolve">
        <LabeledInput
          inputType="textarea"
          inputName="message"
          placeholder="Please enter your resolution"
          inputValue={this.state.message}
          onChange={e => this.setState({ message: e.target.value })}
        />
        <Button bsSize="small" bsStyle="warning" onClick={this.props.onClose.bind(this)}>
          Cancel
        </Button>
        <Button
          bsSize="small"
          onClick={this.saveNewMessage.bind(this)}
          disabled={!this.state.message}
        >
          <i className="fa fa-check-circle " /> Resolve
        </Button>
      </div>
    );
  }
}

export default ResolveFlagForm;
